import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import 'rxjs/add/operator/map';
import { TransferService } from './../../services/transfer.service';
import { AlertService } from './../../providers/alert.service';
import { LoaddingService } from '../../providers/loadding.service';
import { AppConfig } from '../../app/app.config';
import { FormBuilder, Validators } from '@angular/forms';
import { KaiYuanService } from '../../services/kaiyuan.service';
import { EbetService } from '../../services/ebet.service';
import { GamMaService } from './../../services/gamMa.service';
import { ImGamingService } from './../../services/imgaming.service';
import { ShaBaService } from '../../services/shaba.service';
import { YaBoService } from '../../services/yabo.service';
import { YaBoLiveService } from '../../services/yabolive.service';
import { SysconfigService } from '../../services/sysconfig.service';
import { BaiShengService } from '../../services/baisheng.service';
import { KaiXuanService } from '../../services/kaixuan.service';
import { YaXingService } from '../../services/yaxing.service';
import { PmService } from '../../services/pm.service';
import { StorageService } from '../../providers/storage.service';


@Component({
    selector: 'page-transfer',
    templateUrl: 'transfer.html',
    providers: [
        TransferService,
        AlertService,
        YaBoService,
        YaBoLiveService,
        SysconfigService,
        BaiShengService,
        KaiXuanService,
        YaXingService,
        PmService

    ]
})
export class TransferPage {
    thirdGameArr = [];
    thirdBananceBox = {};
    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        private transferService: TransferService,
        public ViewCtrl: ViewController,
        private alertService: AlertService,
        private config: AppConfig,
        private loadding: LoaddingService,
        private formBuilder: FormBuilder,
        private kaiYuanService: KaiYuanService,
        private eService: EbetService,
        private gamMaService: GamMaService,
        private imService: ImGamingService,
        private sbService: ShaBaService,
        private yaboService: YaBoService,
        private yaboliveService: YaBoLiveService,
        private sys: SysconfigService,
        private bsService: BaiShengService,
        private KxService: KaiXuanService,
        private yxService: YaXingService,
        private storage: StorageService,
        private pmService: PmService
    ) {
        let ThirdList: any = this.storage.read('THIRD_GAMES') || [];
        if (ThirdList.length) {
            ThirdList.forEach(el => {
                let obj = { name: el['name'], value: el['code'] };
                this.thirdGameArr.push(obj);
                this.thirdBananceBox[el['code']] = 0;
                this.getThirdBalanceChar(el['code']);
            });
        }
        this.thirdGameArr.unshift({ name: "彩票账户", value: "lottery", isShow: true });
        this.tranForm['To'] = this.thirdGameArr[1].code;
    }
    load;
    kyBalance: number;
    gamMaBalance: number;
    IMBalance: number;
    userMoney: number;
    agMoney: number;
    texMoney: number;
    ptMoney: number;
    // 亚博棋牌账户余额
    yaboBalance: number;
    // 亚博真人账户余额
    yaboliveBalance: number;
    sbBalance: number;
    // ebet账户余额
    ebetBalance: number = 0.00;
    /**BS百胜棋牌余额 */
    bsBalance: number = 0.00;
    imtBalance: number = 0.00;
    crBalance: number = 0.00;
    pgBalance: number = 0.00;
    obBalance: number = 0.00;
    kxBalance: number = 0.00;
    yxBalance: number = 0.00;
    pmBalance: number = 0.00;
    bgBalance: number = 0.00;
    OuBoBalance: number = 0.00;
    From: string;
    To: string;
    Amount: number;
    isShowKaiYuan: boolean = false;
    isShowGamMa: boolean = false;
    isShowYaBo: boolean = false;
    isShowYaBoLive: boolean = false;
    isShowEbet: boolean = false;
    isShowIM: boolean = false;
    isShowImt: boolean = false;
    isShowCR: boolean = false;
    isShowPG: boolean = false;
    isShowAio: boolean = false;
    isShowBaiSheng: boolean = false;
    isShowAg: boolean = false;
    isShowOb: boolean = false;
    isShowKaiXuan: boolean = false;
    isShowYx: boolean = false;
    isShowPm: boolean = false;
    isShowBg: boolean = false;
    isShowOuBo: boolean = false;
    accounts = {
        account: [
            { name: "彩票账户", value: "lottery", isShow: null },


            { name: "PA真人", value: "ag", isShow: null },
            { name: "DB真人", value: "pm", isShow: null },
            { name: "BG真人", value: "bg", isShow: null },
            { name: "WE真人", value: "ebet", isShow: null },
            { name: "欧博真人", value: "oubo", isShow: null },
            { name: "BS百胜棋牌", value: "bs", isShow: null },
            { name: "KY开元棋牌", value: "ky", isShow: null },
            { name: "CR皇冠体育", value: "cr", isShow: null },
            { name: "IM体育", value: "imt", isShow: null },
            { name: "DB体育", value: "ob", isShow: null },
            { name: "PG电子", value: "pg", isShow: null },
            { name: "YX真人", value: "yx", isShow: null },
            { name: "凯旋棋牌", value: "kx", isShow: null },
            { name: "GM棋牌", value: "gamma", isShow: null },
            { name: "IM电竞", value: "im", isShow: null },
            { name: "沙巴体育", value: "sb", isShow: null },
        ]
    };
    tranForm = this.formBuilder.group({
        'Amount': ['', [Validators.required]],
        'From': ['', [Validators.required]],
        'To': ['', [Validators.required]]
    });
    transferInput = new transferInput();

    //页面加载获取各账户的余额信息
    //chen 2017-01-04
    ionViewDidLoad() {
        // this.getThirdIsOpen();
        this.getAllMoney();
        // this.getKaiYuanBalance();
        // this.getEbetBalance();
        // this.getGamMaBalance();
        // this.getIMBalance();
        // this.getShaBaBalance();
        // this.getYaBoBalance();
        // this.getYaBoLiveBalance();
        // this.getBaiShengBalance();
        // this.getImtBalance();
        // this.getObBalance();
    }

    getThirdBalanceChar(code) {
        switch (code) {
            case 'bg':
                this.getBgBalance();
                break;
            case 'bs':
                this.getBaiShengBalance();
                break;
            case 'cr':
                this.getCRBalance();
                break;
            case 'ebet':
                this.getEbetBalance();
                break;
            case 'im':
                this.getIMBalance();
                break;
            case 'im2':
                this.getImtBalance();
                break;
            case 'jm':
                this.getGamMaBalance();
                break;
            case 'kx':
                this.getKxBalance();
                break;
            case 'ky':
                this.getKaiYuanBalance();
                break;
            case 'ob':
                this.getObBalance();
                break;
            case 'oubo':
                this.getOuBoBalance();
                break;
            case 'pg':
                this.getPGBalance();
                break;
            case 'pmreal':
                this.getPmBalance();
                break;
            case 'sb':
                this.getShaBaBalance();
                break;
            case 'yx':
                this.getyxBalance();
                break;
            default:
                if (code != 'ag') {
                    this.getThirdBalance(code);
                }
                break;
        }
    }

    /**
     * 新三方游戏余额
     */
    getThirdBalance(code) {
        this.imService.getThirdBalance(code).then(res => {
            if (res.Result) {
                this.thirdBananceBox[code] = parseFloat(res.Error);
            }
        })
    }

    /**
     * 从平台转账到 新三方
     */
    transferToThird(Input, code) {
        this.load = this.loadding.showLoding();
        this.imService.transferToThird(Input.Amount, code).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!")
                this.getThirdBalance(code);
                this.getAllMoney();
            }
            else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!")
        })
    }

    /**
     * 从 新三方 转账到平台
     */
    transferFromThird(Input, code) {
        this.load = this.loadding.showLoding();
        this.imService.transferFromThird(Input.Amount, code).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!");
                this.getThirdBalance(code);
                this.getAllMoney();

            } else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
        })
    }

    // 判断第三方游戏是否开启
    getThirdIsOpen() {
        this.sys.getThirdIsOpen().then(s => {
            this.isShowAg = s.ag;
            this.isShowKaiYuan = s.ky;
            this.isShowGamMa = s.jm;
            this.isShowYaBo = s.yb;
            this.isShowYaBoLive = s.yblive;
            this.isShowEbet = s.ebet;
            this.isShowPm = s.pmreal;
            this.isShowBg = s.bg;
            this.isShowIM = s.im;
            this.isShowImt = s.im2;
            this.isShowCR = s.cr;
            this.isShowPG = s.pg;
            this.isShowAio = s.sb;
            this.isShowBaiSheng = s.bs;
            this.isShowOb = s.ob;
            this.isShowYx = s.yx;
            this.isShowKaiXuan = s.kx;
            this.isShowOuBo = s.oubo;
            this.accounts = {
                account: [
                    { name: "彩票账户", value: "lottery", isShow: true },
                    { name: "PA真人", value: "ag", isShow: s.ag },
                    { name: "DB真人", value: "pm", isShow: s.pmreal },
                    { name: "BG真人", value: "bg", isShow: s.bg },
                    { name: "WE真人", value: "ebet", isShow: s.ebet },
                    { name: "欧博真人", value: "oubo", isShow: s.oubo },
                    { name: "BS百胜棋牌", value: "bs", isShow: s.bs },
                    { name: "KY开元棋牌", value: "ky", isShow: s.ky },
                    { name: "CR皇冠体育", value: "cr", isShow: s.cr },
                    { name: "IM体育", value: "imt", isShow: s.im2 },
                    { name: "DB体育", value: "ob", isShow: s.ob },
                    { name: "PG电子", value: "pg", isShow: s.pg },
                    { name: "YX真人", value: "yx", isShow: s.yx },
                    { name: "凯旋棋牌", value: "kx", isShow: s.kx },
                    { name: "GM棋牌", value: "gamma", isShow: s.jm },
                    { name: "IM电竞", value: "im", isShow: s.im },
                    { name: "沙巴体育", value: "sb", isShow: s.sb },
                    // { name: "YB棋牌", value: "yabo", isShowYaBo: s.yb },
                    // { name: "YB真人", value: "yabolive", isShowYaBoLive: s.yblive }
                ]
            };
            if (this.isShowEbet) {
                this.getEbetBalance();
            }
            if (this.isShowYx) {
                this.getyxBalance();
            }
            if (this.isShowBaiSheng) {
                this.getBaiShengBalance();
            }
            if (this.isShowKaiYuan) {
                this.getKaiYuanBalance();
            }
            if (this.isShowKaiXuan) {
                this.getKxBalance();
            }
            if (this.isShowGamMa) {
                this.getGamMaBalance();
            }
            if (this.isShowIM) {
                this.getIMBalance();
            }
            if (this.isShowImt) {
                this.getImtBalance();
            }
            if (this.isShowCR) {
                this.getCRBalance();
            }
            if (this.isShowPG) {
                this.getPGBalance();
            }
            if (this.isShowOb) {
                this.getObBalance();
            }
            if (this.isShowAio) {
                this.getShaBaBalance();
            }
            if (this.isShowPm) {
                this.getPmBalance();
            }
            if (this.isShowBg) {
                this.getBgBalance();
            }
            if (this.isShowOuBo) {
                this.getOuBoBalance();
            }

        });

    }
    // 获取全部余额
    getAllMoney() {
        let load = this.loadding.showLoding();
        this.transferService.getUserBalance().then(s => {
            this.userMoney = s.UserMoney;
            this.agMoney = s.AgMoney;
            // this.texMoney = s.TexMoney;
            // this.ptMoney = s.PtMoney;
            this.loadding.closeLoading(load);
        }).catch(err => {
            this.loadding.closeLoading(load);
            console.log(err);
        });
    }
    /**
* 获取BS百胜棋牌余额
*/
    getBaiShengBalance() {
        this.bsService.getBaiShengBalance().then((res) => {
            if (res && res.Result) {
                this.bsBalance = parseFloat(res.Error);
            } else {
                this.bsBalance = 0.00;
            }
        }).catch((err) => {
            console.log(err);
        })
    }
    /**
    * 从平台账户转账到BS百胜棋牌账户
    */
    transferToBaiSheng(Input) {
        this.load = this.loadding.showLoding();
        this.bsService.transferToBaiSheng(Input.Amount).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!")
                this.getBaiShengBalance();
                this.getAllMoney();
            } else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!")
        })
    }

    /**
    * 从BS百胜棋牌账户到平台账户转账
    */
    transferFromBaiSheng(Input) {
        this.load = this.loadding.showLoding();
        this.bsService.transferFromBaiSheng(Input.Amount).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!");
                this.getBaiShengBalance();
                this.getAllMoney();

            } else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
        })
    }
    /**
     *获取ebet账户余额
     *
     *
     */
    getEbetBalance() {
        this.eService.getEbetBalance().then(s => {
            if (s.Result) {
                this.ebetBalance = parseFloat(s.Error);
                let t = setTimeout(() => {
                    clearTimeout(t);
                }, 150);
            }
        }).catch(err => {
            console.log(err);
        })
    }
    /**
       * 获取KY开元棋牌余额
       * evan 2018-12-17
       * @memberof KaiYuanComponent
       */
    getKaiYuanBalance() {
        this.kaiYuanService.getKaiYuanBalance().then((res) => {
            if (res && res.Result) {
                this.kyBalance = parseFloat(res.Error);
            } else {
                this.kyBalance = 0.00;
            }
        }).catch((err) => {
            console.log(err);
        })
    }
    /**
     * @params 获取加玛棋牌余额
     * @param author An 2019-12-05
     */
    getGamMaBalance() {
        this.gamMaService.getGamMaBalance().then((res) => {
            if (res && res.Result) {
                this.gamMaBalance = parseFloat(res.Error);
            } else {
                this.gamMaBalance = 0.00;
            }
        }).catch((err) => {
            console.log(err);
        })
    }
    /**
     * 获取亚博棋牌余额
     */
    getYaBoBalance() {
        this.yaboService.getYaBoBalance().then((res) => {
            if (res && res.Result) {
                this.yaboBalance = parseFloat(res.Error);
            } else {
                this.yaboBalance = 0.00;
            }
        }).catch((err) => {
            console.log(err);
        })
    }
    /**
     * 获取亚博真人余额
     */
    getYaBoLiveBalance() {
        this.yaboliveService.getYaBoLiveBalance().then((res) => {
            if (res && res.Result) {
                this.yaboliveBalance = parseFloat(res.Error);
            } else {
                this.yaboliveBalance = 0.00;
            }
        }).catch((err) => {
            console.log(err);
        })
    }
    /**
     * 获取Im余额
     * An 2019-12-25
    */
    getIMBalance() {
        this.imService.getBalance().then((res) => {
            if (res && res.Result) {
                this.IMBalance = parseFloat(res.Error);
            } else {
                this.IMBalance = 0.00;
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    /**
     * 获取沙巴余额
     * @param Input
     */
    getShaBaBalance() {
        this.sbService.getBalance().then((res) => {
            if (res && res.Result) {
                this.sbBalance = parseFloat(res.Error);
            } else {
                this.sbBalance = 0.00;
            }
        }).catch((err) => {
            console.log(err);
        })
    }
    //转账
    //chen 2017-01-05
    doTransfer(Input) {
        if (Input.From == 'ky' && Input.To == 'lottery' || Input.From == 'lottery' && Input.To == 'ky') {
            //进入开元转账
            // 1.开元--->彩票
            if (Input.From == 'ky') {
                this.transferFromKaiYuan(Input);
            } else {
                // 2.彩票--->开元
                this.transferToKaiYuan(Input);
            }
            return;
        } else if (Input.From == 'bs' && Input.To == 'lottery' || Input.From == 'lottery' && Input.To == 'bs') {
            //进入百胜转账
            // 1.百胜--->彩票
            if (Input.From == 'bs') {
                this.transferFromBaiSheng(Input);
            } else {
                // 2.彩票--->百胜
                this.transferToBaiSheng(Input);
            }
            return;
        }
        else if (Input.From == 'jm' && Input.To == 'lottery' || Input.From == 'lottery' && Input.To == 'jm') {
            //进入加玛转账
            // 1.加玛--->彩票
            if (Input.From == 'jm') {
                this.transferFromGamMa(Input);
            } else {
                // 2.彩票--->加玛
                this.transferToGamMa(Input);
            }
            return;
        } else if (Input.From == 'yabo' && Input.To == 'lottery' || Input.From == 'lottery' && Input.To == 'yabo') {
            //进入亚博棋牌转账
            // 1.亚博棋牌--->彩票
            if (Input.From == 'yabo') {
                this.transferFromYaBo(Input);
            } else {
                // 2.彩票--->亚博棋牌
                this.transferToYaBo(Input);
            }
            return;
        } else if (Input.From == 'yabolive' && Input.To == 'lottery' || Input.From == 'lottery' && Input.To == 'yabolive') {
            //进入亚博真人转账
            // 1.亚博真人--->彩票
            if (Input.From == 'yabolive') {
                this.transferFromYaBoLive(Input);
            } else {
                // 2.彩票--->亚博真人
                this.transferToYaBoLive(Input);
            }
            return;
        } else if (Input.From == 'im' && Input.To == 'lottery' || Input.From == 'lottery' && Input.To == 'im') {
            //进入加玛转账
            // 1.IM--->彩票
            if (Input.From == 'im') {
                this.transferFromIM(Input);
            } else {
                // 2.彩票--->IM
                this.transferToIM(Input);
            }
            return;
        } else if (Input.From == 'sb' && Input.To == 'lottery' || Input.From == 'lottery' && Input.To == 'sb') {
            //进入AIO体育转账
            // 1.AIO体育--->彩票
            if (Input.From == 'sb') {
                this.transferFromShaBa(Input);
            } else {
                // 2.彩票--->AIO体育
                this.transferToShaBa(Input);
            }
            return;
        } else if (Input.From == 'ebet' && Input.To == 'lottery' || Input.From == 'lottery' && Input.To == 'ebet') {
            //进入ebet转账
            // 1.ebet--->彩票
            if (Input.From == 'ebet') {
                this.ebettransfer(Input, 1);
            } else {
                // 2.彩票--->ebet
                this.ebettransfer(Input, 0);
            }
            return;
        } else if (Input.From == 'im2' && Input.To == 'lottery' || Input.From == 'lottery' && Input.To == 'im2') {
            //进入百胜转账
            // 1.im体育--->彩票
            if (Input.From == 'im2') {
                this.transferFromImt(Input);
            } else {
                // 2.彩票--->im体育
                this.transferToImt(Input);
            }
            return;
        } else if (Input.From == 'cr' && Input.To == 'lottery' || Input.From == 'lottery' && Input.To == 'cr') {
            // 1.CR皇冠体育--->彩票
            if (Input.From == 'cr') {
                this.transferFromCR(Input);
            } else {
                // 2.彩票--->CR皇冠体育
                this.transferToCR(Input);
            }
            return;
        } else if (Input.From == 'pg' && Input.To == 'lottery' || Input.From == 'lottery' && Input.To == 'pg') {
            // 1.PG电子--->彩票
            if (Input.From == 'pg') {
                this.transferFromPG(Input);
            } else {
                // 2.彩票--->PG电子
                this.transferToPG(Input);
            }
            return;
        } else if (Input.From == 'ob' && Input.To == 'lottery' || Input.From == 'lottery' && Input.To == 'ob') {
            // 1.ob体育--->彩票
            if (Input.From == 'ob') {
                this.transferFromOb(Input);
            } else {
                // 2.彩票--->ob体育
                this.transferToOb(Input);
            }
            return;
        } else if (Input.From == 'kx' && Input.To == 'lottery' || Input.From == 'lottery' && Input.To == 'kx') {
            // 1.凯旋棋牌--->彩票
            if (Input.From == 'kx') {
                this.transferFromKx(Input);
            } else {
                // 2.彩票--->凯旋棋牌
                this.transferToKx(Input);
            }
            return;
        } else if (Input.From == 'yx' && Input.To == 'lottery' || Input.From == 'lottery' && Input.To == 'yx') {
            // 1.亚星真人--->彩票
            if (Input.From == 'yx') {
                this.transferFromyx(Input);
            } else {
                // 2.彩票--->亚星真人
                this.transferToyx(Input);
            }
            return;
        } else if (Input.From == 'pmreal' && Input.To == 'lottery' || Input.From == 'lottery' && Input.To == 'pmreal') {

            // DB真人--->彩票
            if (Input.From == 'pmreal') {
                this.transferFromPm(Input);
            } else {
                // 2.彩票--->DB真人
                this.transferToPm(Input);
            }
            return;
        } else if (Input.From == 'bg' && Input.To == 'lottery' || Input.From == 'lottery' && Input.To == 'bg') {

            // bg真人--->彩票
            if (Input.From == 'bg') {
                this.transferFromBg(Input);
            } else {
                // 2.彩票--->bg真人
                this.transferToBg(Input);
            }
            return;
        } else if (Input.From == 'oubo' && Input.To == 'lottery' || Input.From == 'lottery' && Input.To == 'oubo') {

            // 欧博真人--->彩票
            if (Input.From == 'oubo') {
                this.transferFromOuBo(Input);
            } else {
                // 2.彩票--->欧博真人
                this.transferToOuBo(Input);
            }
            return;
        } else if(Input.From != 'ag' && Input.To != 'ag'){
            // 1.新三方 ---> 彩票
            if (Input.To == 'lottery') {
                this.transferFromThird(Input, Input.From)
            } else {
                // 2.彩票---> 新三方
                this.transferToThird(Input, Input.To);
            }
        }
        this.transferService.doTransfer(Input).then(s => {
            this.alertService.showAlert(s.Error);
            if (s.Result) {
                this.ionViewDidLoad();
            }
        }).catch(c => {

        });
    }
    //ebet转账
    ebettransfer(input, n) {
        this.load = this.loadding.showLoding();
        //0 -- 转到ebet账户， 1 -- 转到彩票账户
        var a = n;
        var b = input.Amount;
        if (b == "0" || b == "") {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("请输入转账金额并且不能为0！");
            return false;
        } else {
            this.eService.transfer(b, a).then(s => {
                if (s.Result) {
                    this.loadding.closeLoading(this.load);
                    this.alertService.showAlert("转账成功！");
                    this.getAllMoney();
                    this.getEbetBalance();
                } else {
                    this.loadding.closeLoading(this.load);
                    this.alertService.showAlert("转账失败!");
                }
            }).catch(err => {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败!");
            })
        }
    }
    /**
     * @param Input
     * 从平台到亚博棋牌账户
     */
    transferToYaBo(Input) {
        this.load = this.loadding.showLoding();
        this.yaboService.transferToYaBo(Input.Amount).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!")
                this.getYaBoBalance();
                this.ionViewDidLoad();
            }
            else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!")
        })
    }
    /**
     * @param Input
     * 从平台到亚博棋牌账户
     */
    transferFromYaBo(Input) {
        this.load = this.loadding.showLoding();
        this.yaboService.transferFromYaBo(Input.Amount).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!")
                this.getYaBoBalance();
                this.ionViewDidLoad();
            }
            else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!")
        })
    }

    /**
     * @param Input
     * 从平台到亚博真人账户
     */
    transferToYaBoLive(Input) {
        this.load = this.loadding.showLoding();
        this.yaboliveService.transferToYaBoLive(Input.Amount).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!")
                this.getYaBoLiveBalance();
                this.ionViewDidLoad();
            }
            else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!")
        })
    }
    /**
     * @param Input
     * 从平台到亚博棋牌账户
     */
    transferFromYaBoLive(Input) {
        this.load = this.loadding.showLoding();
        this.yaboliveService.transferFromYaBoLive(Input.Amount).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!")
                this.getYaBoLiveBalance();
                this.ionViewDidLoad();
            }
            else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!")
        })
    }

    /**
  * 从平台到AIO体育
  * @param Input
  * An 2020-01-07
  */
    transferToShaBa(Input) {
        this.load = this.loadding.showLoding();
        this.sbService.transferToSb(Input.Amount).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!")
                this.getShaBaBalance();
                this.ionViewDidLoad();
            }
            else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!")
        })
    }
    /**
     * 从AIO体育到平台
     * An 2020-01-07
     */
    transferFromShaBa(Input) {
        this.load = this.loadding.showLoding();
        this.sbService.transferFromSb(Input.Amount).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!");
                this.getShaBaBalance();
                this.ionViewDidLoad();

            } else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
        })
    }
    /**
    * 从平台账户转账到KY开元棋牌账户
    * TQQ 2018-12-10
    */
    transferToKaiYuan(Input) {
        this.load = this.loadding.showLoding();
        this.kaiYuanService.transferToKaiYuan(Input.Amount).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!")
                this.getKaiYuanBalance();
                this.ionViewDidLoad();
            }
            else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!")
        })
    }

    /**
     * 从KY开元棋牌账户到平台账户转账
     * TQQ 2018-12-10
     */
    transferFromKaiYuan(Input) {
        this.load = this.loadding.showLoding();
        this.kaiYuanService.transferFromKaiYuan(Input.Amount).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!");
                this.getKaiYuanBalance();
                this.ionViewDidLoad();

            } else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
        })
    }
    /**
     * @params 从平台账户转账到加玛棋牌账户
     * @param author An 2019-12-05
     */
    transferToGamMa(Input) {
        this.load = this.loadding.showLoding();
        this.gamMaService.transferToGamMa(Input.Amount).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!")
                this.getGamMaBalance();
                this.ionViewDidLoad();
            }
            else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!")
        })
    }
    /**
     * @params 从加玛棋牌账户转账到平台
     * @param author An 2019-12-05
     */
    transferFromGamMa(Input) {
        this.load = this.loadding.showLoding();
        this.gamMaService.transferFromGamMa(Input.Amount).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!");
                this.getGamMaBalance();
                this.ionViewDidLoad();

            } else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
        })
    }
    /**
     * 从平台转账到IM
     */
    transferToIM(Input) {
        this.load = this.loadding.showLoding();
        this.imService.transferToGamIM(Input.Amount).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!")
                this.getIMBalance();
                this.ionViewDidLoad();
            }
            else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!")
        })
    }
    /**
     * 从im转账到平台
     */
    transferFromIM(Input) {
        this.load = this.loadding.showLoding();
        this.imService.transferFromIM(Input.Amount).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!");
                this.getIMBalance();
                this.ionViewDidLoad();

            } else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
        })
    }
    /**
     * im体育余额
     */
    getImtBalance() {
        this.imService.getImtBalance().then(res => {
            if (res.Result) {
                this.imtBalance = parseFloat(res.Error)
            }
        })
    }


    /**
     * CR皇冠体育余额
     */
    getCRBalance() {
        this.imService.getCRBalance().then(res => {
            if (res.Result) {
                this.crBalance = parseFloat(res.Error)
            }
        })
    }

    /**
     * PG电子余额
     */
    getPGBalance() {
        this.imService.getPGBalance().then(res => {
            if (res.Result) {
                this.pgBalance = parseFloat(res.Error)
            }
        })
    }

    /**
     * 从平台转账到IM体育
     */
    transferToImt(Input) {
        this.load = this.loadding.showLoding();
        this.imService.transferToImt(Input.Amount).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!")
                this.getImtBalance();
                this.getAllMoney();
            }
            else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!")
        })
    }
    /**
     * 从im体育转账到平台
     */
    transferFromImt(Input) {
        this.load = this.loadding.showLoding();
        this.imService.transferFromImt(Input.Amount).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!");
                this.getImtBalance();
                this.getAllMoney();

            } else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
        })
    }

    /**
     * 从平台转账到CR皇冠体育
     */
    transferToCR(Input) {
        this.load = this.loadding.showLoding();
        this.imService.transferToCR(Input.Amount).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!")
                this.getCRBalance();
                this.getAllMoney();
            }
            else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!")
        })
    }
    /**
     * 从CR皇冠体育转账到平台
     */
    transferFromCR(Input) {
        this.load = this.loadding.showLoding();
        this.imService.transferFromCR(Input.Amount).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!");
                this.getCRBalance();
                this.getAllMoney();

            } else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
        })
    }

    /**
     * 从PG电子转账到平台
     */
    transferFromPG(Input) {
        this.load = this.loadding.showLoding();
        this.imService.transferFromPG(Input.Amount).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!");
                this.getPGBalance();
                this.getAllMoney();

            } else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
        })
    }

    /**
     * 从平台转账到IM体育
     */
    transferToPG(Input) {
        this.load = this.loadding.showLoding();
        this.imService.transferToPG(Input.Amount).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!")
                this.getPGBalance();
                this.getAllMoney();
            }
            else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!")
        })
    }

    /**
    * ob体育余额
    */
    getObBalance() {
        this.yaboService.getObBalance().then(res => {
            if (res.Result) {
                this.obBalance = parseFloat(res.Error)
            }
        })
    }
    /**
     * 从平台转账到OB体育
     */
    transferToOb(Input) {
        this.load = this.loadding.showLoding();
        this.yaboService.transferToOb(Input.Amount).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!")
                this.getObBalance();
                this.getAllMoney();
            }
            else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!")
        })
    }
    /**
     * 从OB体育转账到平台
     */
    transferFromOb(Input) {
        this.load = this.loadding.showLoding();
        this.yaboService.transferFromOb(Input.Amount).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!");
                this.getObBalance();
                this.getAllMoney();

            } else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
        })
    }
    /**
     * 凯旋棋牌余额
     */
    getKxBalance() {
        this.KxService.getBalance().then(res => {
            if (res.Result) {
                this.kxBalance = parseFloat(res.Error)
            }
        })
    }
    /**
 * 从平台转账到凯旋棋牌
 */
    transferToKx(Input) {
        this.load = this.loadding.showLoding();
        this.KxService.transferToGamKX(Input.Amount).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!")
                this.getKxBalance();
                this.getAllMoney();
            }
            else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!")
        })
    }
    /**
     * 从凯旋棋牌转账到平台
     */
    transferFromKx(Input) {
        this.load = this.loadding.showLoding();
        this.KxService.transferFromKX(Input.Amount).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!");
                this.getKxBalance();
                this.getAllMoney();

            } else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
        })
    }


    /**
     * 凯旋棋牌余额
     */
    getyxBalance() {
        this.yxService.getBalance().then(res => {
            if (res.Result) {
                this.yxBalance = parseFloat(res.Error)
            }
        })
    }
    /**
 * 从平台转账到亚星真人
 */
    transferToyx(Input) {
        this.load = this.loadding.showLoding();
        this.yxService.transferToGamYx(Input.Amount).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!")
                this.getyxBalance();
                this.getAllMoney();
            }
            else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!")
        })
    }
    /**
     * 从亚星真人转账到平台
     */
    transferFromyx(Input) {
        this.load = this.loadding.showLoding();
        this.yxService.transferFromYx(Input.Amount).then((res) => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!");
                this.getyxBalance();
                this.getAllMoney();

            } else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
        })
    }
    /**
       * DB真人游戏余额
       */
    getPmBalance() {
        this.pmService.getPmBalance().then(res => {
            if (res.Result) {
                this.pmBalance = parseFloat(res.Error);
            }
        })
    }
    /**
  * @params DB真人转到平台
  */
    transferFromPm(Input) {
        this.load = this.loadding.showLoding();
        this.pmService.transferFromPm(Input.Amount).then(res => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!");
                this.getPmBalance();
                this.getAllMoney();

            } else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
        })
    }
    /**
     * 平台转到DB真人
     */
    transferToPm(Input) {
        this.load = this.loadding.showLoding();
        this.pmService.transferToPm(Input.Amount).then(res => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!");
                this.getPmBalance();
                this.getAllMoney();

            } else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
        })
    }
    /**
     *  bg真人余额
     */
    getBgBalance() {
        this.pmService.getBgBalance().then(res => {
            if (res.Result) {
                this.bgBalance = parseFloat(res.Error);
            }
        })
    }

    /**
  * @params bg真人转到平台
  */
    transferFromBg(Input) {
        this.load = this.loadding.showLoding();
        this.pmService.transferFromBg(Input.Amount).then(res => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!");
                this.getBgBalance();
                this.getAllMoney();

            } else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
        })
    }
    /**
     * 平台转到bg真人
     */
    transferToBg(Input) {
        this.load = this.loadding.showLoding();
        this.pmService.transferToBg(Input.Amount).then(res => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!");
                this.getBgBalance();
                this.getAllMoney();

            } else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
        })
    }

    /**
     *  欧博真人余额
     */
    getOuBoBalance() {
        this.imService.getOuBoBalance().then(res => {
            if (res.Result) {
                this.OuBoBalance = parseFloat(res.Error);
            }
        })
    }

    /**
     * @params 欧博真人转到平台
     */
    transferFromOuBo(Input) {
        this.load = this.loadding.showLoding();
        this.imService.transferFromOuBo(Input.Amount).then(res => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!");
                this.getOuBoBalance();
                this.getAllMoney();

            } else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
        })
    }
    /**
     * 平台转到欧博真人
     */
    transferToOuBo(Input) {
        this.load = this.loadding.showLoding();
        this.imService.transferToOuBo(Input.Amount).then(res => {
            if (res && res.Result) {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账成功!");
                this.getOuBoBalance();
                this.getAllMoney();

            } else {
                this.loadding.closeLoading(this.load);
                this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
            }
        }).catch((err) => {
            this.loadding.closeLoading(this.load);
            this.alertService.showAlert("转账失败，请联系客服或者稍后重试!");
        })
    }



    //关闭窗口
    //chen 2017-01-04
    close() {
        this.ViewCtrl.dismiss();
    }

}

export class transferInput {
    Amount: number;
    From: string;
    To: string;
}



// WEBPACK FOOTER //
// ./src/pages/transfer/transfer.ts